export enum ArtifactType {
    NONE = 'None',
    MESSAGE_DOCUMENT = 'MessageDocument',
    MESSAGE_BODY_DOCUMENT = 'MessageBodyDocument',
}
